import React from 'react';
import CardLayout from '../common/CardLayout';
import ReactTable, { CellInfo } from 'react-table-6';
import TreeTableHOC from '../common/TreeTableHOC';
import { useIntl } from "react-intl";
import { Grid, Form, Pagination, PaginationProps } from 'semantic-ui-react'


const DEFAULT_PROPS = {
  closeable: true,
  toggleable: true,
  defaultBackground: true,
  hideHeaderIcon: false,
  onGetOrderSummary: () => { },
  orderSummaryLoading: false,
  orderSummaryData: {},
  enableMargin: true,
}
const CardOrderSummaryView = (propsParam) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined))
  }
  const intl = useIntl();
  const oneDayData = props.orderSummaryData.oneDay ? props.orderSummaryData.oneDay : []
  const continueData = props.orderSummaryData.continue ? props.orderSummaryData.continue : []
  const TreeTable = TreeTableHOC(ReactTable);
    
  const handlePaginationChange = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, data: PaginationProps) => {
    props.setCurrentPagination(data?.activePage as number)
  }
  console.log('CardOrderSummaryView props: ', props);

  return (
    <CardLayout
      titleText='Order Summary'
      headerColor='yellow'
      closeable={props.closeable}
      toggleable={props.toggleable}
      defaultBackground={props.defaultBackground}
      hideHeaderIcon={props.hideHeaderIcon}
      loading={props.orderSummaryLoading}
      enableMargin={props.enableMargin}
    >
      <Grid columns={2}>
        <Grid.Column>
          <TreeTable
            style={{ height: 370, backgroundColor: '#FFFFFF' }}
            showPagination={false}
            noDataText={intl.formatMessage({ id: "ไม่มีข้อมูล" })}
            data={oneDayData}
            
            pageSize={oneDayData ? (oneDayData.length < 12 ? 12 : oneDayData.length) : 12}
            pivotBy={["real_order_time"]}
            columns={[{
              accessor: 'real_order_time',
              classname: 'real_order_time',
            }, {
              Header: 'Order',
              accessor: 'order_time',
              style: { 'whiteSpace': 'unset' },
              Cell: (oneDay: CellInfo) => {
                return (
                  <Form >
                    <Form.Field className='inline'>
                      { oneDay?.original?.order_time && <div dangerouslySetInnerHTML={{ __html: oneDay.original.order_time }} />}
                    </Form.Field>
                  </Form>
                );
              }
            },
            {
              Header: 'รายการคำสั่งแพทย์',
              accessor: 'summary',
              style: { 'whiteSpace': 'unset' },
              Cell: (oneDay: CellInfo) => {
                return (
                  oneDay?.original?.summary && <div dangerouslySetInnerHTML={{ __html: oneDay.original.summary }} /> 
                );
              }
            },
            {
              Header: 'รับคำสั่ง',
              accessor: 'nurse_order',
              style: { 'whiteSpace': 'unset' },
              Cell: (oneDay: CellInfo) => {
                return (
                  <Form >
                    <Form.Field>
                      { oneDay?.original?.nurse_order && <div dangerouslySetInnerHTML={{ __html: oneDay.original.nurse_order }} /> }
                    </Form.Field>
                  </Form>
                );
              },
            }]}
          />
        </Grid.Column>
        <Grid.Column>
          <TreeTable
            style={{ height: 370, backgroundColor: '#FFFFFF' }}
            showPagination={false}
            noDataText={intl.formatMessage({ id: "ไม่มีข้อมูล" })}
            data={continueData}
            pageSize={continueData ? (continueData.length < 12 ? 12 : continueData.length) : 12}
            pivotBy={["real_order_time"]}
            columns={[{
              Header: 'Real order time',
              accessor: 'real_order_time'
            },
            {
              Header: 'Order',
              accessor: 'order_time',
              style: { 'whiteSpace': 'unset' },
              Cell: (grdContinue: CellInfo) => {
                return (
                  <Form >
                    <Form.Field className='inline'>
                      <div dangerouslySetInnerHTML={{ __html: grdContinue.original?.order_time }} />
                    </Form.Field>
                  </Form>
                );
              }
            },
            {
              Header: 'รายการคำสั่งแพทย์',
              accessor: 'summary',
              style: { 'whiteSpace': 'unset' },
              Cell: (grdContinue: CellInfo) => {
                return (
                  <div dangerouslySetInnerHTML={{ __html: grdContinue.original?.summary }} />
                );
              }
            },
            {
              Header: 'รับคำสั่ง',
              accessor: 'nurse_order',
              style: { 'whiteSpace': 'unset' },
              Cell: (grdContinue: CellInfo) => {
                return (
                  <Form >
                    <Form.Field>
                      <div dangerouslySetInnerHTML={{ __html: grdContinue.original?.nurse_order }} />
                    </Form.Field>
                  </Form>
                );
              },
            }]}
          />
        </Grid.Column>
      </Grid>
      {Math.ceil(props.totalPage) > 1 ? <Pagination
          pointing
          secondary
          activePage={props.currentPagination}
          onPageChange={handlePaginationChange}
          totalPages={Math.ceil(props.totalPage)}
        /> : null}
    </CardLayout>
  )
}

export default CardOrderSummaryView;
